<template>
  <div class="maintenance-subtitle">
    <div>
      <span>{{ $t('scheduled-maintenance-subtitle-part-one') }}</span>
      <span><strong>{{ $t('scheduled-maintenance-subtitle-part-two-date') }}</strong></span>
      <span>{{ $t('scheduled-maintenance-subtitle-part-three') }}</span>
    </div>
    <div>{{ $t('scheduled-maintenance-subtitle-part-four') }}</div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">

.maintenance-subtitle {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: $bodyText;
  max-width: 396px;
  margin: 0;
}
</style>


